import { Table$ } from '@thesisedu/ui'
import React from 'react'

import { StudentActionsDropdown } from './StudentActionsDropdown'
import { StudentTableStudent } from './StudentsTable'

export function ActionsCell({ item }: Table$.ImperativeTableRenderCellProps<StudentTableStudent>) {
  return <StudentActionsDropdown students={[{ studentId: item.id, classId: item.classId }]} />
}
